import { render, staticRenderFns } from "./ItemsEditor.vue?vue&type=template&id=97549be8&"
import script from "./ItemsEditor.vue?vue&type=script&lang=js&"
export * from "./ItemsEditor.vue?vue&type=script&lang=js&"
import style0 from "./ItemsEditor.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports